import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/shared/services/data.service";
import { Subscription } from "rxjs";

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  merchantSubscription: Subscription;
  address: string;
  merchant: any = {};
  merchantAddress: string = " ";
  merchantName: string = " ";

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.getMerchant();
  }
  getMerchant() {
    this.merchantSubscription = this.dataService.merchantDetails.subscribe(
      (data) => {
        this.merchant = data;
        this.merchantName = this.merchant.companyName;
      }
    );


    this.dataService.merchantConfig.subscribe(
      (data: any) => {
          this.merchantAddress = data.merchant_region;    
      }
    );
  }
}
